module.exports = __webpack_public_path__ + "img/img54.5bc12832.png";